
import WDDropdown from './wd-dropdown';
import WDModelItems from '../wd-model-items';
import WDElementCollapsible from '../wd-element-collapsible';
import WDButton from '../button/wd-button';

export default class WDDropdownAccordion extends WDDropdown
{
	#initted = false;
	constructor(cfg)
	{
		if (!cfg?.groupField) throw new Error('groupField not given for wd-dropdown-accordion');

		super(cfg);
		return this;
	};

	connectedCallback()
	{
		super.connectedCallback();

		if (!this.#initted)
		{
			this.#initted = true;
			/*
			this.parentElement.addEventListener('keydown', (evt) =>
			{
				this.handleListKeydown(evt);
			}, true);
			*/
		}
	}

	groupedModel(data)
	{
		const groupField = this.config.groupField;

		//reset the list
		const newOptions = [];

		// Iterate through each item in the data array
		data.forEach(item =>
		{
			// Get the group label from the item using the groupField
			const groupLabel = item[groupField];
			const gfOpened = this.config.groupFieldOpen;

			//find an option
			let group = newOptions.find(x => x.label == groupLabel);
			if (!group)
			{
				group = {
					label: groupLabel,
					isOpen: gfOpened.includes(groupLabel) || gfOpened.includes('*'),
					items: []
				};

				newOptions.push(group);
			}

			group.items.push(item);
		});

		//if there's only one group, default it to open
		if (newOptions.length == 1)
		{
			newOptions[0].isOpen = true;
		}

		return newOptions;
	};

	filterGroupedModel(data)
	{
		const groupField = this.config.groupField;

		return [
			{
				label: 'Search Results',
				items: data,
				isOpen: true,
			}
		];
	};

	get model() { return super.model; };	//required because we overrode the setter
	set model(data)
	{
		super.model = this.isFiltering ? this.filterGroupedModel(data) : this.groupedModel(data);
	};


	buildModelItem(value)
	{
		const groupContainer = wdc(`<div class="wd-dropdown-group"/>`);
		this.append(groupContainer);

		const isCollapsed = value?.isOpen !== true;
		if (!isCollapsed) groupContainer.classList.add('is-open');

		const content = new WDElementCollapsible({ collapsed: isCollapsed });
		content.on('element:open element:opened', () => groupContainer.classList.add('is-open'));
		content.on('element:close element:closed', () => groupContainer.classList.remove('is-open'));

		const toggleBtn = new WDButton({ label: value.label, fasIcon: 'chevron-right' });
		toggleBtn.tabIndex = -1;
		toggleBtn.classList.add('wd-dropdown-group-toggle');
		toggleBtn.on('click', (evt) => content.toggle());

		groupContainer.append(toggleBtn, content);

		//create an option list that reflects the group
		const itemList = new WDModelItems({
			createItemHandler: data => {
				const item = this.createModelItem(data);

				//not my favorite, but keeps us from keyboarding to a hidden item
				item.on('focusin', evt => {
					const group = item.closest('wd-element-collapsible');
					if (!group.isOpen()) group.toggle();
				});
				return item;
			}
		});

		itemList.model = value?.items || [];
		content.append(itemList);

		//carry it up - we only track when group items are selected, no the headers
		itemList.on('item:selected', evt =>
		{
			this.trigger('item:selected', evt.detail);
		});
	};


	handleListKeydown(evt)
	{
		return; 
		
		this.stopEvent(evt);
		console.log('here',evt.key);
		//only handle events in the dropdown group, or on the toggle button
		if (evt.key == 'ArrowDown' || evt.key == 'ArrowUp' || evt.key == ' ')
		{
			const elem = evt.target;
			const optGroup = elem.closest('.wd-dropdown-group');
			const isToggle = elem.classList.contains('wd-dropdown-group-toggle');

			if (isToggle || optGroup)
			{
				console.log('HKD',isToggle,optGroup);
				if (evt.key == ' ' && isToggle)
				{
					elem.nextSibling.toggle();
					this.stopEvent(evt);
				}
				else if (optGroup)
				{
					if (evt.key == 'ArrowDown') this.handleArrowDown(evt);
				}
			}
			//coming from a parent element, focus on the first toggle
			else
			{
				this.querySelector('.wd-dropdown-group-toggle').focus();
			}
	
		}

	}

	stopEvent(evt)
	{
		evt.preventDefault();
		evt.stopPropagation();
	}

	handleArrowDown(evt)
	{
		const elem = evt.target;
		const optGroup = elem.closest('.wd-dropdown-group');
		const isToggle = elem.classList.contains('wd-dropdown-group-toggle');

		//a normal item
		if (elem.classList.contains('dropdown-item'))
		{
			const pe = elem.parentElement;
			//if we are the last item in the list, try to go to the next group
			if (pe.children[pe.children.length-1] == elem)
			{
				//find the next group
				if (optGroup.nextSibling)
				{
					optGroup.nextSibling.querySelector('.wd-dropdown-group-toggle').focus();
				}
				this.stopEvent(evt);
	
			}	
		}
		//on a toggle button
		else if (isToggle)
		{

		}

	}
};

customElements.define('wd-dropdown-accordion', WDDropdownAccordion);

